<template>
    <form class="signup-form">
        <div class="text-center" style="color:white">
         <v-icon dark >mdi-map-marker-plus</v-icon>
         {{ $t('postMenu.NEWGOODAY') }}</div>
        <v-divider dark class="my-4 mx-4"></v-divider>
        <div class="text-center" style="color:white">
         <v-icon dark >mdi-city</v-icon>
         {{ $t('postMenu.ITEM1') }}</div>
        <v-chip-group 
        prepend-icon="mdi-city"
        max="1" 
        column 
        dark
        centered
        v-model="city"
        active-class="purple accent-3"
        @click="$v.city.touch()">
        <v-chip v-for="city in cities" :key="city">
        {{ city }}
        </v-chip>
        </v-chip-group>
        <v-divider dark class="my-4 mx-4"></v-divider>
        <div class="text-center" style="color:white">
         <v-icon dark >mdi-home-group</v-icon>
         {{ $t('postMenu.ITEM2') }}</div>
        <v-chip-group 
        prepend-icon="mdi-city"
        multiple
        max="3" 
        column 
        dark
        v-model="hood"
        active-class="purple accent-3"
        @click="$v.hood.touch()">
        <v-chip v-for="hood in hoods" :key="hood">
        {{ hood }}
        </v-chip>
        </v-chip-group>
        <v-divider dark class="mx-4 my-4"></v-divider>
        <div class="text-center" style="color:white">
         <v-icon dark >mdi-toolbox</v-icon>
         {{ $t('postMenu.ITEM3') }}</div>
        <v-chip-group 
        prepend-icon="mdi-toolbox"
        multiple
        max="3" 
        column 
        dark
        v-model="gig"
        active-class="purple accent-3"
        @click="$v.gig.touch()">
        <v-chip v-for="skill in gigs" :key="skill">
        {{ skill }}
        </v-chip>
        </v-chip-group>
        <v-divider dark class="mx-4"></v-divider>
        <v-textarea
        v-model="intro"
        :label="$t('postMenu.ITEM4')"
        :counter="120"
        :error-messages="introErrors"
        dark
        required
        @input="$v.intro.$touch()"
        @blur="$v.intro.$touch()"></v-textarea>
        <image-cropping v-on:listingPicture="imageData = $event" ></image-cropping>
        <v-checkbox
        v-model="policyAgreement"
        :label="$t('postMenu.ITEM6')"
        dark
        required
        :error-messages="policyAgreementErrors"
        @input="$v.policyAgreement.$touch()"
        @blur="$v.policyAgreement.$touch()"></v-checkbox>
      <v-btn 
      :disabled="$v.$invalid || !croppedImage" 
      color="purple accent-3"
      @click="post">
        <v-icon left="left">mdi-send</v-icon><span>{{ $t('postMenu.POST') }}</span>
      </v-btn>
    </form>
</template>

<script>
import { required,maxLength } from 'vuelidate/lib/validators';
import { citiesMixin } from '../mixins/cities';
import { gigsMixin } from '../mixins/gigs';
import Cropping from './Cropping.vue';
import router from '../../router';
import firebase from 'firebase/app';
import 'firebase/storage';
import 'firebase/firestore';
import 'firebase/database';
import 'firebase/auth';
export default {
    mixins : [
        citiesMixin,
        gigsMixin,
    ],
    components: {
        imageCropping: Cropping,
    },
    data() {
        return {
            isEditing: false,
            city: 0,
            hood: [],
            gig: [],
            intro:'',
            imageData: null,
            croppedImage: false,
            policyAgreement: false,
            selectedFile: null,
            imageURL: '',
        }
    },
    validations: {
        city: {
            required,
        },
        hood: {
            required,
        },
        gig: {
            required,
        },
        intro: {
            required,
            maxLen: maxLength(120)
        },
        policyAgreement: {
            checked (val) {
                return val
            },
        },

    },
    methods: {
        clear() {
            this.city = ''
            this.lastName = ''
            this.email = ''
            this.password = ''
            this.confirmPassword = ''
            this.policyAgreement = false
        },
        post() {
            const imageName = firebase.auth().currentUser.uid + '.png'
            this.imageData.toBlob( (imageBlob) => {
                // const formData = new FormData()
                // formData.append('metadata',{
                //     name: imageName,
                // })
                // formData.append('croppedImage',imageBlob,imageName)
                var storageRef = firebase.storage() .ref()
                var uploadTask = storageRef.child('adboard/'+firebase.auth().currentUser.uid+'/'+imageName).put(imageBlob);
                // Listen for state changes, errors, and completion of the upload.
                uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
                (snapshot) => {
                    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                    var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    // eslint-disable-next-line no-console
                    console.log('Upload is ' + progress + '% done');
                    switch (snapshot.state) {
                    case firebase.storage.TaskState.PAUSED: // or 'paused'
                        // eslint-disable-next-line no-console
                        console.log('Upload is paused');
                        break;
                    case firebase.storage.TaskState.RUNNING: // or 'running'
                        // eslint-disable-next-line no-console
                        console.log('Upload is running');
                        break;
                    }
                }, (error) => {

                // A full list of error codes is available at
                // https://firebase.google.com/docs/storage/web/handle-errors
                switch (error.code) {
                    case 'storage/unauthorized':
                    // User doesn't have permission to access the object
                    // eslint-disable-next-line no-console
                    console.log('user doesnt have permission')
                    break;

                    case 'storage/canceled':
                    // User canceled the upload
                    // eslint-disable-next-line no-console
                    console.log('upload is canceled')
                    break;

                    case 'storage/unknown':
                    // Unknown error occurred, inspect error.serverResponse
                    // eslint-disable-next-line no-console
                    console.log('unknown error')
                    break;
                }
                }, () => {
                // Upload completed successfully, now we can get the download URL
                uploadTask.snapshot.ref.getDownloadURL()
                .then((downloadURL) => {
                    // eslint-disable-next-line no-console
                    console.log('File available at', downloadURL);
                    this.imageURL = downloadURL
                    // add user post
                    const postTime = new Date().toLocaleString()
                    const postData = {
                        city: this.cities[this.city],
                        gigs: this.selectedGigs,
                        hoods: this.selectedHoods,
                        imageURL: this.imageURL,
                        introduction: this.intro,
                        postedBy: this.$store.getters['auth/userName'],
                        postedAt: postTime,
                        userId: firebase.auth().currentUser.uid,
                        phoneNumber: this.$store.getters['auth/phone'],
                        email: this.$store.getters['auth/email']
                    }
                    var db = firebase.firestore()
                    db.collection('goodays').doc(firebase.auth().currentUser.uid).set(postData)
                    .then((docRef) => {
                        // eslint-disable-next-line no-console
                        console.log("Document written with ID: ",docRef)
                        // update feeddocs - keeps list of updated gooday posts
                         firebase.database().ref('/feed/'+ this.userId).set(postData)
                         .then(() => {
                        // eslint-disable-next-line no-console
                        console.log('new user registration success!')
                        router.push('/feed')
                        } )
                        .catch( error => {
                            // eslint-disable-next-line no-console
                            console.log(error)
                        })
                        firebase.database().ref('/feed/'+ this.userId).off()
                        // add doc to allposts collection
                        db.collection('allposts').add(postData)
                        .then((docRef) => {
                                // eslint-disable-next-line no-console
                                console.log("Document written with ID: ",docRef.id)
                        })
                        .catch(error => {
                            // eslint-disable-next-line no-console
                            console.log(error)
                        })
                    },        
                    )
                    .catch((error) => {
                        // eslint-disable-next-line no-console
                        console.log(error)
                    })

                });
                });
            })
        }, 
        debug(foo) {
            // eslint-disable-next-line no-console
            console.log(foo)
        }  
    },
    computed: {
        userId() {
            return firebase.auth().currentUser.uid
        },
        cities() {
            const cityList = []
            this.ethiopiaCities.forEach(element => {
                cityList.push(element.city)
            });
            return cityList
        },
        selectedHoods() {
            const myHoods = []
            this.hood.forEach(element => {
                myHoods.push(this.hoods[element])
            })
            return myHoods
        },
        hoods() {
            const hoods = ['-']
            const selectedCity = this.cities[this.city]
            this.ethiopiaCities.forEach(element => {
                if (element.city === selectedCity) {
                    hoods.push(...element.neighborhoods)
                } 
            })
           return hoods
        },
        // gigs() {
        //     return gigs
        // },
        selectedGigs() {
            const myGigs = []
            this.gig.forEach( element => {
                myGigs.push(this.gigs[element])
            })
            return myGigs 
        },
        cityErrors() {
            const errors = []
            if (!this.$v.city.$dirty) return errors
            !this.$v.city.required && errors.push(this.$t('postMenu.CITYERROR'))
            return errors
        },
        hoodErrors() {
            const errors = []
            if (!this.$v.hood.$dirty) return errors
            !this.$v.hood.required && errors.push(this.$t('postMenu.HOODERROR'))
            return errors
        },
        gigErrors() {
            const errors = []
            if (!this.$v.gig.$dirty) return errors
            !this.$v.gig.required && errors.push(this.$t('postMenu.GIGERROR'))
            return errors
        },
        introErrors() {
            const errors = []
            if (!this.$v.gig.$dirty) return errors
            !this.$v.intro.required && errors.push(this.$t('postMenu.INTROERROR'))
            !this.$v.intro.maxLen && errors.push(this.$t('postMenu.INTROMAXERROR'))
            return errors
        },
        policyAgreementErrors() {
            const errors = []
            if (!this.$v.policyAgreement.$dirty) return errors
            !this.$v.policyAgreement.checked && errors.push(this.$t('postMenu.POLICYERROR'))
            return errors
        },
        
    },
    watch: {
        'imageData': function() { 
            // eslint-disable-next-line no-console
            console.log("watching imageData: ",this.imageData)
            this.croppedImage = !this.croppedImage         }
    },
}
</script>

<style scoped>
 .signup-form {
    max-width: 520px;
    margin: 30px auto;
    border: 1px solid #eee;
    padding: 20px;
    box-shadow: 0 2px 3px #ccc;
  }
.image-container{
  display: inline-block;
  max-width: 270px;
  }

.image-preview {
  display: block;
  max-height: 229px;
  max-width: 100%;
}

</style> 